import router from './index'
import store from '@/store'
import { getToken } from '@/utils/auth'

// 白名单路径，无需登录即可访问
const whiteList = ['/login', '/loading', '/project-select', '/403', '/404']

router.beforeEach(async (to, from, next) => {
  const token = getToken()

  // 未登录：白名单放行，其他跳转登录页
  if (!token) {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
    return
  }

  // 已登录访问登录页：跳转 loading
  if (to.path === '/login') {
    next('/loading')
    return
  }

  // 白名单路径直接放行
  if (whiteList.includes(to.path)) {
    next()
    return
  }

  // 已有用户信息直接放行
  if (store.state.user.userInfo) {
    next()
    return
  }

  // 无用户信息时从缓存恢复，并重新生成菜单权限
  try {
    const userInfo = await store.dispatch('user/refreshUserInfo')
    store.dispatch('permission/generateMenu', userInfo)
    next()
  } catch (error) {
    store.dispatch('user/logout')
    next('/login')
  }
})
